import present from 'present';

/**
 * Creates a new Timer object for counting time.
 *
 * @param {Object} object Options object.
 * @param {Boolean} object.ms True to enable counting milliseconds, false otherwise. Counting
 * milliseconds has a noticeable impact on processor usage for the timer.
 * @param {Function} object.onTick Callback to call on each timer tick, whether it be each second
 * or each millisecond.
 * @param {Function} nowTime Function used to fetch current time. Defaults to `present`, which
 * defaults to process.hrtime for node and performance.now / Date.now for browser.
 */
export default function createTimer(
	{ ms = true, onTick = Function.prototype } = { ms: true, onTick: Function.prototype },
	nowTime = present,
) {
	let pausedElapsed = 0;
	let timer = null;
	const state = {
		start: null,
		tickRate: ms ? 1 : 1000,
	};
	const getElapsed = () => nowTime() - state.start;
	const tick = () => {
		const elapsed = getElapsed();
		onTick(elapsed);
	};
	const start = () => {
		if (timer !== null) {
			return;
		}
		if (!state.start) {
			state.start = nowTime();
		} else {
			state.start = nowTime() - pausedElapsed;
		}
		timer = setInterval(() => tick(), 1);
	};
	const stop = () => {
		clearInterval(timer);
		timer = null;
		pausedElapsed = getElapsed();
	};
	const reset = () => {
		state.start = nowTime();
		pausedElapsed = 0;
		onTick(0);
	};

	return {
		start,
		stop,
		reset,
	};
}



// WEBPACK FOOTER //
// ./src/components/Timer.js